import { h } from 'preact';
import React, { Component } from 'react';

import { Sanitize } from '../../Sanitize/Sanitize';
import Toggle from '../Components/Toggle';

import { formatDescription, makeText, isActionAllowed } from '../../../util';

export default class PurposeContent extends Component {
  state = {
    consentAll: false,
  }
  toggleConsentAll = () => {
    const consentAll = !this.state.consentAll;
    this.setState({ consentAll }, this.props.force);
  }
  render() {
    const {
      selected,
      purpose,
      settings,
      language,
      force,
      dev,
      disclosure,
      isCustom,
      accordionOpen
    } = this.props;

    const { consentAll } = this.state;
    const viewAllText = makeText(Boolean(dev), settings, 'viewAllText', language);
    const viewLessText = makeText(Boolean(dev), settings, 'viewLessText', language);

    const description = isCustom
      ? (
        <p style="margin-bottom:15px;" dangerouslySetInnerHTML={{ __html: Sanitize({ html: purpose.description }) }} />
      )
      : (
        <p style="margin-bottom:15px;">
          {formatDescription(purpose.description)}
        </p>
      );

    if (settings.alphabetizeVendors) {
      if (purpose.requiringConsentVendors) {
        purpose.requiringConsentVendors.sort((a, b) =>{
          if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
    }

    return (
      <div className="purpose-content">
        {description}
        <div>
          <div className="policies">
            {purpose.requiringConsentVendors.slice(0, consentAll ? purpose.requiringConsentVendors.length : 3)
              .map((v) => (
                <Toggle
                  vendor={v}
                  key={v._id}
                  language={language}
                  settings={settings}
                  force={force}
                  accordionOpen={accordionOpen}
                />
              ))}
            {purpose.requiringConsentVendors.length > 3 && (
              <div
                tabIndex={accordionOpen ? 0 : -1}
                className="view-all"
                onClick={this.toggleConsentAll}
                onKeyDown={e => isActionAllowed(e.key) && this.toggleConsentAll()}
              >
                {consentAll ? viewLessText : viewAllText}
              </div>
            )}
          </div>
        </div>

      </div>
    );
  }
}